module.exports = __webpack_public_path__ + "img/testCenter1.aeb9af8d.png";